import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <section
      className="mx-auto flex min-h-[65vh] max-w-3xl flex-col items-center justify-center px-6 py-20 text-center"
      aria-labelledby="not-found-title"
    >
      <p className="mb-3 text-sm font-semibold uppercase tracking-[0.2em] text-blue-700">404</p>
      <h1 id="not-found-title" className="text-4xl font-bold text-slate-950 sm:text-5xl">
        העמוד לא נמצא
      </h1>
      <p className="mt-5 max-w-xl text-lg leading-8 text-slate-600">
        ייתכן שהקישור השתנה או שהכתובת אינה נכונה. אפשר לחזור לעמוד הבית או להמשיך
        לקטלוג המוצרים.
      </p>
      <div className="mt-8 flex flex-wrap justify-center gap-3">
        <Link
          to="/"
          className="rounded-full bg-blue-700 px-6 py-3 font-semibold text-white transition hover:bg-blue-800 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
        >
          חזרה לעמוד הבית
        </Link>
        <Link
          to="/catalog"
          className="rounded-full border border-slate-300 bg-white px-6 py-3 font-semibold text-slate-900 transition hover:border-slate-400 hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
        >
          לקטלוג המוצרים
        </Link>
      </div>
    </section>
  );
}
